import {getConfig} from '@logistics-frontend/core/config/selectors'
import {CountryCode} from '@logistics-frontend/core/types'
import {flatMap, fromEntries, pipe} from '@logistics-frontend/utils'
import {useMemo} from 'react'
import {useSelector} from 'react-redux'

import * as ConfigSelector from './selectors'
import {Config, WithConfig} from './types'

export const useSupportedCountries = () => useSelector(ConfigSelector.getSupportedCountries)

export const useConfig = () => useSelector((state: WithConfig) => getConfig<Config>(state))

export const useCurrencySignByCountryCode = (countryCode: CountryCode) =>
  useSelector(ConfigSelector.getCurrencySignByCountryCode(countryCode))

export const usePhoneI18nMasksConfig = () => {
  const {
    phones: {rules: phoneConfigRules = []},
  } = useConfig()

  // [{mask: 'xxx', prefixes: ['+7', '8']}] => {'7': '###', '8': '###'}
  return useMemo<Record<string, string>>(
    () =>
      pipe(
        phoneConfigRules,
        flatMap(({prefixes, mask}) =>
          prefixes.map(prefix => [prefix.replace('+', ''), mask.replace(/x/g, '#')] as const),
        ),
        fromEntries,
      ),
    [phoneConfigRules],
  )
}
